import * as Sentry from '@sentry/nextjs';

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV ?? process.env.NODE_ENV,

    // Route events through our own server to bypass ad blockers.
    tunnel: '/api/sentry-tunnel',

    // What goes to Sentry besides the error. Cookies hold the session token, request bodies hold passwords,
    // phones and addresses: neither is sent. Local variables of stack frames aren't sent either.
    dataCollection: {
        userInfo: true,
        cookies: false,
        httpBodies: [],
        stackFrameVariables: false,
    },

    // Capture 100% of transactions to get full trace context on errors.
    // Lower this (e.g. 0.1) if event volume becomes an issue.
    tracesSampleRate: 1.0,

    // Always keep the replay of the session that led to an error — this is what
    // shows where the bug actually came from.
    replaysOnErrorSampleRate: 1.0,

    // Share of ordinary, error-free sessions that get recorded. Replays are billed
    // separately from errors, so set this to 0 to keep only the error replays.
    replaysSessionSampleRate: 0.1,

    integrations: [
        // Adds current route name and page navigation spans to every event.
        Sentry.browserTracingIntegration(),

        // Captures failed HTTP responses (4xx / 5xx) from client-side fetch as Sentry events.
        Sentry.httpClientIntegration({
            failedRequestStatusCodes: [[400, 599]],
        }),

        // Records a video-like replay of the DOM. The store handles phone numbers,
        // addresses and passwords, so text and media stay out of the recording —
        // only layout and interactions are captured.
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
});
